import { Eleve } from '@teetsh/app/src/types/eleves';
import setYear from '@teetsh/app/src/utils/time/setYear';
import getYear from '@teetsh/app/src/utils/time/getYear';
import isAfter from '@teetsh/app/src/utils/time/isAfter';
import isBefore from '@teetsh/app/src/utils/time/isBefore';
import isSameDay from '@teetsh/app/src/utils/time/isSameDay';

export function getElevesBirthdaysBetweenDates(
  eleves: Eleve[],
  from: Date,
  to: Date,
): Eleve[] {
  return eleves.filter(ev => {
    if (!ev.birthday) {
      return false;
    }

    let birthday = setYear(ev.birthday, getYear(to));
    if (getYear(to) !== getYear(from)) {
      const test = setYear(ev.birthday, getYear(from));
      if (isBefore(test, from)) {
        birthday = setYear(ev.birthday, getYear(to));
      } else {
        birthday = setYear(ev.birthday, getYear(from));
      }
    }

    return (
      (isAfter(birthday, from) && isBefore(birthday, to)) ||
      isSameDay(birthday, from) ||
      isSameDay(birthday, to)
    );
  });
}
